<card
  [title]="student.user.displayName"
  [detailUrl]="['/students/' + student.uid]"
  [editUrl]="['/admin/student/' + student.uid]"
  [user]="user"
  [isGrid]="isGrid"
>
</card>
